import React from "react"
import PropTypes from "prop-types"
import { Button } from "reactstrap"

const reasons = {
  timeout: "The Sportya server did not answer in time, so your session could not be confirmed.",
  network: "Could not reach the Sportya server. Check your connection.",
  server: "The Sportya server is temporarily unavailable.",
}

// Shown instead of the full-page spinner when the session check gets no usable
// answer: the user is not signed out, so offer a retry rather than the login page.
const SessionUnavailable = ({ reason, retrying, onRetry }) => (
  <div className="align-items-center d-flex justify-content-center min-vh-100">
    <div className="col-12 col-md-8 col-lg-5">
      <div className="card mb-0">
        <div className="card-body" role="alert">
          <h4>The server is not responding</h4>
          <p>{reasons[reason] || reasons.server}</p>
          <Button color="primary" onClick={onRetry} disabled={retrying}>
            {retrying ? "Trying again…" : "Try again"}
          </Button>
        </div>
      </div>
    </div>
  </div>
)

SessionUnavailable.propTypes = {
  reason: PropTypes.oneOf(["timeout", "network", "server"]),
  retrying: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
}

export default SessionUnavailable
